<template>
  <div class="mt-4">
    <h4>{{ $t('message.roomDetails') }}</h4>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label for="RoomNumber">{{ $t('message.roomNumber') }}</label>
        <input
          v-validate="'required'"
          id="RoomNumber"
          :disabled="isAmadeous"
          v-model="editModel.RoomNumber"
          name="roomNumber"
          type="text"
          class="form-control"
        />
        <div
          class="invalid-feedback"
        >{{ OOErrors.first("roomNumber") | inputNameLocale("roomNumber")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoomDelivery",
  props: {
    editModel: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isAmadeous() {
      if (this.$route.query.room || localStorage.getItem("room")) {
        return true;
      }
      return false;
    }
  },
  methods: {
    syncFirstName(firstName) {
      if (this.$parent.syncFirstName) this.$parent.syncFirstName(firstName);
    },
    validate() {
      return this.$validator.validateAll();
    }
  }
};
</script>
